/** 所傳入 [states] props 的 index */
export const index = {
  mobilePhone: 0,
};
